import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import {
    verticalAlign,
    tableLayout,
    borderCollapse,
    borderSpacing,
    top,
} from '../utils/customPropStyles';

export const Table = styled<any, any>('table', 'table', 'grid')`
    ${propStyles};
    ${tableLayout};
    ${borderCollapse};
    ${borderSpacing};
`;

Table.defaultProps = {
    width: '100%',
    tableLayout: 'fixed',
    borderCollapse: 'collapse',
};

export const TableHead = styled<any, any>('thead', 'tableHead', 'grid')`
    ${propStyles};
    ${top};
`;

export const TableBody = styled<any, any>('tbody', 'tableBody', 'grid')`
    ${propStyles};
`;

export const TableRow = styled<any, any>('tr', 'tableRow', 'grid')`
    ${propStyles};
`;

export const ColumnHeader = styled<any, any>('th', 'columnHeader', 'grid')`
    ${propStyles};
    ${verticalAlign};
    ${top};
`;

export const TableCell = styled<any, any>('td', 'tableCell', 'grid')`
    ${propStyles};
    ${verticalAlign};
`;

ColumnHeader.defaultProps = {
    paddingX: 'sm',
    paddingY: 'md',
    minWidth: '10%',
    color: 'inherit',
    fontSize: 'sm',
    fontFamily: 'heading',
    fontWeight: 'medium',
    textAlign: 'left',
    verticalAlign: 'top',
    borderWidth: '2px',
    borderColor: 'gray500',
    borderStyle: 'none none solid none',
};

export const SubColumnHeader = styled<any, any>(
    ColumnHeader,
    'subColumnHeader',
    'grid'
)``;

SubColumnHeader.defaultProps = {
    fontSize: 'xs',
    fontFamily: 'body',
    fontWeight: 'regular',
};

export const ColumnGroup = styled<any, any>('div', 'columnGroup', 'grid')`
    ${propStyles};
`;

ColumnGroup.defaultProps = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
};

export const ColumnGroupLabel = styled<any, any>(
    'div',
    'columnGroupLabel',
    'grid'
)`
    ${propStyles};
`;

ColumnGroupLabel.defaultProps = {
    fontFamily: 'heading',
    fontWeight: 'normal',
    margin: '0 0 0.5em 0',
    padding: '0 0 0.5em 0',
    borderWidth: '1px',
    borderStyle: 'none none solid none',
    borderColor: 'gray500',
};



// WEBPACK FOOTER //
// ./src/Components/Grid.tsx